/**
 * @param {string} token Bearer value must be `sessionId&organizationId`
 */
export async function checkArrowUpPlayedApi({ userId, token, themeName }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/checkArrowUpPlayed`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      themeName: themeName != null && String(themeName).trim() !== '' ? String(themeName).trim() : null,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to check play status');
  }
  return data;
}

export function isArrowRunAlreadyCompleted(data) {
  return Boolean(data && data.played);
}
